import { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { isClientSide } from 'src/utils/isClientSide';

export const useStateSSR = <T>(serverValue: T, clientValue: T) => {
  const [value, setValue] = useState(serverValue);
  useEffect(() => setValue(clientValue), [clientValue]);
  return value;
};

export const useIsClientSideSSR = () => {
  return useStateSSR(false, isClientSide());
};

type UseMediaQueryArguments = Parameters<typeof useMediaQuery>;
type UseMediaQueryResult = ReturnType<typeof useMediaQuery>;

export const useMediaQuerySSR = (
  serverValue: UseMediaQueryResult,
  ...args: UseMediaQueryArguments
) => {
  return useStateSSR(serverValue, useMediaQuery(...args));
};
